import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Bigint = props => {
  var {
    Bigint: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Bigint');
  return null;
};
Bigint.displayName = 'JVR.Bigint';